import { Summaries } from '../../components/RealtyValuation';
import * as React from 'react';

import { Button, ModalWindow } from '@cian/ui-kit';
import { PricesDynamicsContainer } from './containers/PricesDynamicsContainer';
import { useSelector } from 'react-redux';
import { developerValuationFiltersState, selectDeveloperValuationData } from '../../selectors/developerValuation';
import { getPriceDiffTitle } from './utils/getPriceDiffTitle';
import { trackRealtyValuationClick } from './tracking';

export const RealtyValuationMobileContainer = () => {
  const [isOpen, setOpenState] = React.useState(false);
  const realtyValuation = useSelector(selectDeveloperValuationData);
  const pricesFiltersState = useSelector(developerValuationFiltersState);

  const setOpen = React.useCallback(() => {
    setOpenState(true);
    trackRealtyValuationClick();
  }, [setOpenState]);
  const setClose = React.useCallback(() => {
    setOpenState(false);
  }, [setOpenState]);

  const priceDiffTitle = React.useMemo(() => {
    const { period } = pricesFiltersState;

    return getPriceDiffTitle(period);
  }, [pricesFiltersState]);

  const priceDynamics = React.useMemo(() => {
    return realtyValuation?.priceDynamics;
    /** Так и должно быть, обновлять блок не требуется */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Summaries
        avgPrice={priceDynamics?.avgPrice || '—'}
        avgPriceSqm={priceDynamics?.avgPriceSqm || '—'}
        priceDiff={priceDynamics?.priceDiff}
        priceDiffPercent={priceDynamics?.priceDiffPercent}
        priceDiffTrend={priceDynamics?.priceDiffTrend || 'noChange'}
        priceDiffTitle={priceDiffTitle}
        action={
          <Button theme="fill_secondary" onClick={setOpen}>
            Смотреть динамику цены
          </Button>
        }
      />

      <ModalWindow title="Динамика цен" onClose={setClose} open={isOpen} content={<PricesDynamicsContainer />} />
    </>
  );
};
